export default {
   translation: {
      'title': '【回収確認】',
      'action_show': '表示',
      'prompt_password': 'パスワードを入力してください。',
      'error_password': 'パスワードが無効です。',
      'error_404': 'アンケートが見つかりませんでした。',
      'title_quota': '割付表',
      'title_gt': 'GT表',
      'title_answer': '回答者数確認',
      'title_quota_desc1': '※データクリーニング前の数値です。',
      'title_quota_desc2': '※データクリーニングを考慮し、目標回収数には予備サンプルを含めております。',
      'label_gt': 'パート{id}',
      'answer_headers_0': '#',
      'answer_headers_1': '全回答者数',
      'answer_headers_2': '全問回答者数',
      'quota_headers_0': 'No',
      'quota_headers_1': '割付セル名',
      'quota_headers_2': 'セル値',
      'quota_headers_3': '目標回収数',
      'quota_headers_4': '現回収数',
      'quota_headers_5': '不足回収数',
      'quota_headers_6': '状態',
      'quota_status_0': '回収中',
      'quota_status_1': '回収完了',
      'quota_type_1': '「フラグ」',
      'quota_type_23': '「割付」',
      'gt_headers_0': '回答数',
      'gt_headers_1': '%',
      'gt_headers_2': 'カテゴリ',
      'gt_all': '全体',
      'updated_at': '更新時間：',
      'update_text1': '※データクリーニング前の数値です',
   }
}